<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
        <div class="row">
            <div class="col-md-12 rolelist" v-if="Auth.role == 1">
                <div class="addrole">
                    <router-link to="/admin/dashboard/addofflineorder"><a class="">Generate Order</a></router-link>
                </div>
            </div>

            <div class="col-md-12 rolelistupper">
                <div class="card">
                    <h5 class="card-title">Offline Order List</h5>
                    <FlashMessage :position="'right top'"></FlashMessage>

                    <div class="card-body table-responsive table-full-width">

                        <table class="table table-borderd mt-5" id="myTable">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Number</th>
                                    <th>Email</th>
                                    <th>Order Date</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="data in offlineorder" v-bind:key="data.Offline_order_referenceid">
                                    <td>{{data.Offline_order_referenceid}}</td>
                                    <td>{{data.name}}</td>
                                    <td>{{data.number}}</td>
                                    <td>{{data.email}}</td>
                                    <td>{{data.created_at | formatDate}}</td>
                                    <td><button @click.prevent="deleteData(data.Offline_order_referenceid)" class="btnborderremove">
                                            <a>
                                                <b-icon-trash></b-icon-trash>
                                            </a>
                                        </button>&nbsp; &nbsp; <router-link :to="'/admin/dashboard/editofflineorder/' + data.Offline_order_referenceid"><button class="btnborderremove">
                                                <a>
                                                    <b-icon-pencil-square></b-icon-pencil-square>
                                                </a>
                                            </button></router-link>
                                    </td>

                                </tr>
                            </tbody>

                        </table>

                    </div>
                </div>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

    
<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import datatable from "datatables.net-bs4"
import Auth from '../../../Auth.js';
import Vue from 'vue'
import $ from "jquery"
import {
    Table,
    TableColumn
} from 'element-ui'
Vue.use(Table)
Vue.use(TableColumn)
export default {
    name: 'listOfflineOrder',

    components: {
        TopNavbar,
        ContentFooter,
    },

    data() {
        return {
            offlineorder: [],
            Auth: '',
        }
    },

    methods: {

        table() {
            this.$nextTick(() => {
                $('#myTable').DataTable();
            });
        },

        getData() {
            this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/offlineorderlist`).then((res) => {
                this.offlineorder = res.data;
                this.table();
            });
        },

        deleteData(Offline_order_referenceid) {
            this.axios.delete(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/offlineorder/delete/` + Offline_order_referenceid).then((res) => {
                this.getData();
                this.flashMessage.success({
                    message: 'Order Deleted Successfully'
                });
            });
        },

    },

    mounted() {
        this.getData();
        this.Auth = Auth.user;
    },

};
</script>

    
<style lang="scss">

    </style>
